export default __webpack_public_path__ + "static/media/Plain_Background.110d1ed1.png";